import { display, spacingHorizontalS } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${display("table-cell")}

  :host {
    vertical-align: inherit;
    unicode-bidi: isolate;
  }

  .cell-content {
    display: flex;
    align-items: center;
  }

  ::slotted([slot="before"]) {
    margin-inline-end: ${spacingHorizontalS};
  }
`;
//# sourceMappingURL=table-cell.styles.js.map